import { render, staticRenderFns } from "./kw_calendar.vue?vue&type=template&id=04544330&scoped=true&"
import script from "./kw_calendar.vue?vue&type=script&lang=js&"
export * from "./kw_calendar.vue?vue&type=script&lang=js&"
import style0 from "./kw_calendar.vue?vue&type=style&index=0&id=04544330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04544330",
  null
  
)

component.options.__file = "kw_calendar.vue"
export default component.exports